<main id="main" class="main__offset-header">
  <section class="container">
    <h1>Attributions</h1>
    <ngb-accordion
      #acc="ngbAccordion"
      [closeOthers]="true"
      activeIds="EuroGlobalMap"
      (panelChange)="scrollToOpenPanel($event)"
    >
      <ngb-panel title="EuroGlobalMap" id="EuroGlobalMap">
        <ng-template ngbPanelContent>
          <p>EGM data copyright is held by European National Mapping Agencies:</p>
          <table class="table table-sm table-striped">
            <thead>
              <tr class="sr-only">
                <th>Country</th>
                <th>Attribution</th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.EuroGlobalMap">
              <td>{{item.country}}</td>
              <td [innerHTML]=item.attribution_statement></td>
            </tr>
            </tbody>
          </table>
          <p>
            EGM dataset is owned by all National Mapping Agencies above and collectively represented
            by &copy; EuroGeographics
          </p>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="EuroRegionalMap" id="EuroRegionalMap">
        <ng-template ngbPanelContent>
          <p>ERM data copyright is held by European NMCAs and other responsible authorities:</p>
          <table class="table table-sm table-striped">
            <thead class="sr-only">
              <tr>
                <th>Country</th>
                <th>Attribution</th>
                <th>Attribution - English</th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.EuroRegionalMap">
              <td>{{item.country}}</td>
              <td [innerHTML]=item.attribution></td>
              <td [innerHTML]=item.attribution_english></td>
            </tr>
            </tbody>
          </table>
          <p>
            ERM product is owned by all National Mapping and Cadastral Agencies above and
            collectively represented by &copy; EuroGeographics
          </p>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="EuroDEM" id="EuroDEM">
        <ng-template ngbPanelContent>
          <p>EuroDEM data copyright is held by European National Mapping Agencies:</p>
          <table class="table table-sm table-striped">
            <thead class="sr-only">
              <tr>
                <th>Country</th>
                <th>Attribution</th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.EuroDEM">
              <td>{{item.country}}</td>
              <td [innerHTML]=item.attribution_statement></td>
            </tr>
            </tbody>
          </table>
          <p>
            EuroDEM product is owned by all National Mapping Agencies listed above and collectively
            represented by &copy; EuroGeographics
          </p>
        </ng-template>
      </ngb-panel>
            <ngb-panel title="High-value large-scale pan European prototype" id="HVLSP">
        <ng-template ngbPanelContent>
          <p>
            The High-value large-scale pan European prototype is licenced through the EuroGeographics Open licence.
            The High-value large-scale pan European prototype dataset is owned by all National Mapping Agencies listed below, and
            collectively represented by &copy; EuroGeographics
          </p>
          <table class="table table-sm table-striped">
            <thead class="sr-only">
              <tr>
                <th>Country</th>
                <th>Attribution</th>
                <th>Attribution - English</th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.HVLSP">
              <td>{{item.country}}</td>
              <td [innerHTML]=item.attribution></td>
              <td [innerHTML]=item.attribution_english></td>
            </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Open Cadastral Map" id="OpenCadastralMap">
        <ng-template ngbPanelContent>
          <p>OpenCadastralMap data copyright is held by European National Mapping Agencies:</p>
          <table class="table table-sm table-striped">
            <thead class="sr-only">
            <tr>
              <th>Country</th>
              <th>Member</th>
              <th>Attribution</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.OpenCadastralMap">
              <td>{{item.country}}</td>
              <td>{{item.member}}</td>
              <td [innerHTML]=item.attribution_statement></td>
            </tr>
            </tbody>
          </table>
          <p>
            The Open Cadastral Map product is owned by all National Mapping Agencies listed above and collectively
            represented by &copy; EuroGeographics
          </p>
        </ng-template>
      </ngb-panel>
      <ngb-panel title="Open Gazetteer" id="OpenGazetteer">
        <ng-template ngbPanelContent>
          <p>
            The Open Gazetteer is licenced through the EuroGeographics Open licence. The Open
            Gazetteer dataset is owned by all National Mapping Agencies listed below, and
            collectively represented by &copy; EuroGeographics
          </p>
          <table class="table table-sm table-striped">
            <thead class="sr-only">
              <tr>
                <th>Country</th>
                <th>Attribution</th>
              </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of AttributionConstants.OpenGazetteer">
              <td>{{item.member}}</td>
              <td [innerHTML]=item.attribution></td>
            </tr>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </section>
</main>
<app-footer showBackToTop="true" target="main"></app-footer>
